var React = require('react');

function Baby1Inline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 6C15.4183 6 7 13 6 22C6 22 2 22 2 27C2 32 8 32 8 32C10.9925 38.1103 17.0341 44 24 44C30.9659 44 37.0075 38.1101 40 31.9998C40 31.9998 46 31.9998 46 26.9998C46 21.9998 42 21.9998 42 21.9998C41 12.9998 32.5817 6 24 6ZM24 6C22 6 19 7 18 9.99978C16 19.9998 30 19.9998 30 11.9998","stroke":"#FF6A3C","strokeWidth":"3","key":0}),React.createElement("circle",{"cx":"19","cy":"27","r":"3","fill":"#FF6A3C","key":1}),React.createElement("circle",{"cx":"29","cy":"27","r":"3","fill":"#FF6A3C","key":2})]);
}

Baby1Inline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Baby1Inline;

Baby1Inline.default = Baby1Inline;
